/**
 * page-not-found.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

/**
 * {@link EmptyComponent} is a behaviorless, template-less component, mainly
 * for use in development when a component is needed that hasn't been created
 * yet (e.g. for routing or sub-templating).
 */
@Component({
  template: `
  <div class="container">
  <div id="blockNotification" class="well center-block">
    <h2 class="text-center">The page could not be found!</h2>
  </div>
  </div>
  `,
  styles: ["#blockNotification { width: 400px; max-width: 90%;}"]
})
export class PageNotFoundComponent
{
  /**
   * Construct a new {@link EmptyComponent}.
   *
   */
  public constructor (route : ActivatedRoute)
  {
    // TODO: use the route?
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/page-not-found.component.ts